import { useEffect, useRef, useState } from 'react';
import SubMenuDispatcher from './SubMenuDispatcher.jsx';
export default function SubMenu({
  isOpen,
  submenuItems = [],
  controlId,
}) {
  const collapsableMenuRef = useRef(null);
  const [height, setHeight] = useState(0);
  useEffect(() => {
    if (isOpen) {
      setHeight(`${collapsableMenuRef.current.scrollHeight}px`);
    } else {
      setHeight('0px');
    }
  }, [isOpen, collapsableMenuRef]);

  return (
    <>
      <div
        role="region"
        ref={collapsableMenuRef}
        className="lds-header-submenu-container"
        style={{
          maxHeight: height,
        }}
          id={controlId}
      >
        <ul
          className={'lds-header-menu lds-header-menu-submenu'}
        >
          {submenuItems.map((item, index) => (
            <SubMenuDispatcher
              key={index}
              {...item}
              isOpen={isOpen}
              index={index}
            />
          ))}
        </ul>
      </div>
    </>
  );
}
